
<div class="contenEjem mat-elevation-z8">

  <table mat-table [dataSource]="dataSource">

    <!-- Name Column -->
    <ng-container matColumnDef="practice" sticky>
      <th mat-header-cell *matHeaderCellDef style="background-color: #dddddd; text-align: center;">
        {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.PRACT' | translate}}
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field appearance="outline" style="padding: 3px;">
            <mat-label>{{'CERTIFICAR.FORALL.TABLA.INPUTS.PRACT' | translate}}</mat-label>
            <textarea matInput oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'
                 (keyup)="updateText($event,'txtPrac'+element.position,element.position)"
                 (blur)="onBlurPractica($event,'txtPrac'+element.position,element.position);" [value]="element.practice">
                 </textarea>
            <mat-error>Question is required!</mat-error>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="background-color: #dddddd; text-align: center;">
        {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.DESCR' | translate}}
      </th>
      <td mat-cell *matCellDef="let element">
          <mat-form-field appearance="outline" style="padding: 3px;">
            <mat-label>{{'CERTIFICAR.FORALL.TABLA.INPUTS.DESCR' | translate}}</mat-label>
            <textarea matInput oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'
                 (blur)="onBlurDescripcion($event,'txtDesc'+element.position,element.position);" [value]="element.description"></textarea>
            <mat-error>Question is required!</mat-error>
        </mat-form-field>
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="statement1">
      <th mat-header-cell *matHeaderCellDef style="background-color: #dddddd; text-align: center;">
        {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.STT1' | translate}}
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: center;">
        <p style="padding: 10px;" >{{element.statement1Part1}} <code>{{ element.practice }}</code> {{ element.statement1Part2 }} </p>
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="statement2">
      <th mat-header-cell *matHeaderCellDef style="background-color: #dddddd; text-align: center;">
        {{'CERTIFICAR.FORALL.TABLA.ENCABEZADOS.STT2' | translate}}
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: center;">
       <p style="padding: 10px;" >{{element.statement2Part1}} <code>{{ element.practice }}</code> {{ element.statement2Part2 }} <code>{{ nombreEmpresa }}</code>?</p>
      </td>
    </ng-container>

     <!-- Star Column -->
    <ng-container matColumnDef="star" stickyEnd>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon>more_vert</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
